var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronRightLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7506_50687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7501 10.0125C11.5001 9.73824 11.2822 9.48559 11.0578 9.24017C9.5515 7.54383 8.03876 5.84028 6.53243 4.14394C6.15424 3.71805 6.16065 3.12614 6.53243 2.74356C6.82087 2.44761 7.25034 2.41873 7.56442 2.67138C7.62852 2.72191 7.68621 2.77965 7.73749 2.84462C9.64124 4.9885 11.5386 7.12516 13.4423 9.26904C13.8526 9.73102 13.8526 10.2724 13.4423 10.7344C11.5322 12.8855 9.62842 15.0294 7.71826 17.1805C7.29521 17.6569 6.66704 17.5919 6.37218 17.0433C6.1927 16.7113 6.21193 16.307 6.42346 15.9966C6.46833 15.9317 6.5132 15.8811 6.56448 15.8234C8.24388 13.9322 9.91687 12.0409 11.5963 10.1569C11.6347 10.1064 11.6924 10.0703 11.7501 10.0125Z",
    fill: "#424242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7506_50687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightLogo);
export default __webpack_public_path__ + "static/media/chevronRightLogo.1a98b3c11b9c24bfe69fb94edd2e0a5d.svg";
export { ForwardRef as ReactComponent };